import template from './szakertok.pug';
import popupTemplate from './szakertok-popup.pug';
import szakertokServiceModule from './szakertok-service';
const MODULE_NAME = 'szakertok';
class SzakertokController {
	constructor(szakertokService, $uibModal, $document, $scope, $window) {
		'ngInject';
		this._szakertokService = szakertokService;
		this._getSzakertok();
		this._$uibModal = $uibModal;
		this._$document = $document;
		this._$scope = $scope;
		this._$window = $window;
	}
	_showModal() {
		if (this.modalPopup) {
			this.modalPopup.close();
		}
		this.modalPopup = this._$uibModal.open({
			animation: false,
			appendTo: angular.element(document.getElementById('app_experts')),
			backdrop: false,
			scope: this._$scope,
			template: popupTemplate()
		});
	}
	showPopup(megye) {
		this.activeMegye = megye;
		let szakertok = this._szakertok.filter(item => item.id == megye);
		if (szakertok.length) {
			this.megye = szakertok[0];
		} else {
			this.megye = null;
		}
		this._showModal();
	}
	hidePopup() {
		this.modalPopup.close();
		this.activeMegye = null;
	}
	_getSzakertok() {
		this._szakertokService.getSzakertok().then((response) => {
			this._szakertok = response;
		}, () => {
			this.technikaiHiba = true;
		});
	}
}

export default angular.module(MODULE_NAME, [szakertokServiceModule])
	.component('szakertok', {
		controller: SzakertokController,
		template: template()
	}).name;



// WEBPACK FOOTER //
// ./source/applications/szakertok/szakertok.js